<template>
  <!-- page-wrapper Start-->
  <div class="page-wrapper">
    <div class="container-fluid">
      <!-- sign up page start-->
      <div class="authentication-main">
        <div class="row">
          <div class="col-sm-12 p-0">
            <div class="auth-innerright">
              <div class="authentication-box">
                <div class="text-center">
                  <img
                    src="../assets/images/color_logo.png"
                    alt=""
                  >
                </div>
                <div class="card mt-4 p-4">
                  <h4 class="text-center">
                    {{ $t('passwordChange.ifrTyinat') }}
                  </h4>
                  <h6 class="text-center">
                    {{ $t('passwordChange.zhmtOlmasaIfrniziDaxilEdin') }}
                  </h6>
                  <form
                    class="theme-form"
                    @submit.prevent="updatePassword"
                  >
                    <div class="mb-3">
                      <label
                        for="oldPassword"
                        class="form-label"
                      >{{ $t('passwordChange.yeniIfr') }}</label>
                      <div class="input-group">
                        <input
                          id="oldPassword"
                          v-model="password"
                          :type="`${passwordVisible?'text': 'password'}`"
                          class="form-control"
                        >
                        <div class="input-group-append">
                          <button
                            type="button"
                            class="btn btn-light"
                            @click.prevent="passwordVisible=!passwordVisible"
                          >
                            <i :class="`${passwordVisible?'fa fa-eye-slash': 'fa fa-eye'}`" />
                          </button>
                        </div>
                      </div>
                      <ul
                        v-if="scorePassword.unmetRequirements?.length"
                        class="text-danger mt-2"
                      >
                        <li
                          v-for="requirement in scorePassword.unmetRequirements"
                          :key="requirement"
                        >
                          {{ requirement }}
                        </li>
                      </ul>
                    </div>

                    <div class="progress mb-3">
                      <div
                        class="progress-bar"
                        :class="`bg-${scorePassword.color}`"
                        :style="{width: `${scorePassword.percent}%`}"
                        role="progressbar"
                        aria-valuenow="0"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      >
                        {{ scorePassword.name }}
                      </div>
                    </div>

                    <div
                      v-if="scorePassword.percent ===100"
                      class="form-group  mt-3 mb-0 text-center"
                    >
                      <button
                        class="btn btn-primary px-4"
                        type="submit"
                      >
                        {{ $t('passwordChange.ifrTsdiqEt') }}
                      </button>
                    </div>
                  </form>

                  <div class="text-center mt-4">
                    <a
                      class="btn-link text-capitalize"
                      href="#"
                      @click.prevent="logout"
                    >{{ $t('passwordChange.x') }}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- sign up page ends-->
    </div>
  </div>
  <!-- page-wrapper Ends-->
</template>

<script>
import {userSetPassword} from "@/repositories/GeneralDataRepository";
import {mapState} from "vuex";
import {mediaBase} from "@/repositories/Repository";

export default {
  name: 'SignUp',

  data() {
    return {
      mediaBase: mediaBase,
      password: '',
      passwordVisible: false,
    }
  },

  computed: {
    ...mapState({
      token: state => state.auth.token,
    }),
    scorePassword() {
      let score = 0;
      if (!this.password) return score;

      let requirementsMet = 0;
      const unmetRequirements = [];

      // Length check
      if (this.password.length >= 8) {
        requirementsMet++;
      } else {
        unmetRequirements.push(this.$t("passwordChange.requirementLength"));
      }

      // Uppercase letter check
      const hasUpperCase = /[A-Z]/.test(this.password);
      if (hasUpperCase) {
        requirementsMet++;
      } else {
        unmetRequirements.push(this.$t("passwordChange.requirementUpperCase"));
      }

      // Lowercase letter check
      const hasLowerCase = /[a-z]/.test(this.password);
      if (hasLowerCase) {
        requirementsMet++;
      } else {
        unmetRequirements.push(this.$t("passwordChange.requirementLowerCase"));
      }

      // Digit check
      const hasDigit = /\d/.test(this.password);
      if (hasDigit) {
        requirementsMet++;
      } else {
        unmetRequirements.push(this.$t("passwordChange.requirementDigit"));
      }

      // Special character check
      const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(this.password);
      if (hasSpecialChar) {
        requirementsMet++;
      } else {
        unmetRequirements.push(this.$t("passwordChange.requirementSpecialChar"));
      }

      // Calculate score based on requirements met
      score = requirementsMet * 20; // Scale score out of 100


      // Set strength label and color based on requirements met
      let strengthLabel, color;
      switch (requirementsMet) {
        case 1:
          strengthLabel = this.$t("passwordChange.veryWeak");
          color = 'danger';
          break;
        case 2:
          strengthLabel = this.$t("passwordChange.weak");
          color = 'warning';
          break;
        case 3:
          strengthLabel = this.$t("passwordChange.moderate");
          color = 'warning';
          break;
        case 4:
          strengthLabel = this.$t("passwordChange.moderate");
          color = 'warning';
          break;
        case 5:
          strengthLabel = this.$t("passwordChange.strong");
          color = 'success';
          break;
        default:
          strengthLabel = this.$t("passwordChange.veryWeak");
          color = 'danger';
      }

      return {
        name: strengthLabel,
        percent: score,
        color: color,
        unmetRequirements: unmetRequirements, // Return unmet requirements array
      };
    }

  },
  mounted() {

  }
  ,

  methods: {

    updatePassword() {
      if (this.scorePassword.percent < 50) {
        this.$swal({
          title: `Xəta !`,
          text: this.$t("passwordChange.message"),
          icon: 'error',
        })
        return;
      }

      userSetPassword(this.token, this.password).then(({code, message}) => {

        if (code === 200) {
          this.$swal({
            title: this.$t("congratulations"),
            text: this.$t("passwordChange.successMessage"),
            icon: 'success',
          }).then(() => {
            this.$router.push({name: 'welcome'});
          })
        } else if (code === 401 || code === 404) {
          this.$swal({
            title: `Xəta !`,
            text: this.$t("passwordChange.errorMessage"),
            icon: 'error',
          })
        } else {
          this.$swal({
            title: `Error ${code} !`,
            text: message,
            icon: 'error',
          })
        }

      });


    }
    ,
    logout() {
      localStorage.removeItem('token');
      this.$router.push({name: 'login'});
    }
  }
}
</script>
